import PropTypes from 'prop-types'
import React from 'react'
import { Switch, Route, Redirect, useHistory } from 'react-router-dom'

import PrivateLayout from '../components/layout/private'
import { privatePages } from '../config/menu'
import { getSession } from '../utils/session'

const PrivateRoutes = ({ components }) => {
  const history = useHistory()

  const session = getSession('b-bfb')
  const now = new Date().getTime()
  const isAuthenticated = session ? now < session.expired : false

  if (!isAuthenticated) {
    return <Redirect to="/" />
  }

  const Pages = Object.keys(privatePages)

  return (
    <PrivateLayout history={history}>
      <Switch>
        {Pages.map((key) => {
          const page = privatePages[key]
          const Component = components[page.component]
          return (
            <Route
              key={key}
              path={page.path}
              exact
              render={(props) => <Component {...props} />}
            />
          )
        })}
      </Switch>
    </PrivateLayout>
  )
}

PrivateRoutes.propTypes = {
  components: PropTypes.object.isRequired
}

export default PrivateRoutes
